// extracted by mini-css-extract-plugin
module.exports = {"card":"proposalResponseToken_card__32uhh","messageCard":"proposalResponseToken_messageCard__1RPaz","chatCard":"proposalResponseToken_chatCard__2KMqN"};